// Routes owned by the Asset module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const assetPaths = {
    // Assets
    assetsList: '/assets',
    assetCreate: '/assets/new',
    assetDetail: '/assets/:slug',
    assetEdit: '/assets/:id/edit',
} as const
